import { useEffect, useState } from 'react'

const useFontsReady = () => {
  const [fontsReady, setFontsReady] = useState(false)

  useEffect(() => {
    if (typeof document === "undefined" || !document.fonts?.ready) {
      setFontsReady(true)
      return
    }

    let cancelled = false
    document.fonts.ready.then(() => {
      if (!cancelled) setFontsReady(true)
    })

    return () => {
      cancelled = true
    }
  }, [])

  return fontsReady
}

export default useFontsReady
